/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Carriers API
 * Carrier-facing API for the carrier portal (carriers.freightsimple.com).  Authentication: a carrier opens a permanent signed login link, exchanges it for a session token, and presents that token as a bearer on every other call. `CarrierPortalAuthenticationFilter` validates the session and scopes each request to one carrier. Operations use `security: []` (no Micronaut JWT) — the filter is the authenticator, the same model the agents API uses.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CspTimelineEvent
 */
export interface CspTimelineEvent {
  /**
   *
   * @type {string}
   * @memberof CspTimelineEvent
   */
  label: string;
  /**
   * Pre-formatted date the milestone occurred, if known.
   * @type {string}
   * @memberof CspTimelineEvent
   */
  date?: string;
  /**
   * True for a milestone that hasn't happened yet (e.g. expiry).
   * @type {boolean}
   * @memberof CspTimelineEvent
   */
  upcoming: boolean;
}

/**
 * Check if a given object implements the CspTimelineEvent interface.
 */
export function instanceOfCspTimelineEvent(
  value: object,
): value is CspTimelineEvent {
  if (!("label" in value) || value["label"] === undefined) return false;
  if (!("upcoming" in value) || value["upcoming"] === undefined) return false;
  return true;
}

export function CspTimelineEventFromJSON(json: any): CspTimelineEvent {
  return CspTimelineEventFromJSONTyped(json, false);
}

export function CspTimelineEventFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CspTimelineEvent {
  if (json == null) {
    return json;
  }
  return {
    label: json["label"],
    date: json["date"] == null ? undefined : json["date"],
    upcoming: json["upcoming"],
  };
}

export function CspTimelineEventToJSON(json: any): CspTimelineEvent {
  return CspTimelineEventToJSONTyped(json, false);
}

export function CspTimelineEventToJSONTyped(
  value?: CspTimelineEvent | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    label: value["label"],
    date: value["date"],
    upcoming: value["upcoming"],
  };
}
